document.addEventListener("algolia.hooks.initialize", function () {

    const searchOverlay = document.getElementById('search-overlay');
    
    searchOverlay.addEventListener('mouseleave', function(){
      let autocompleteDropdown = document.querySelector('.aa-Panel');

      if (!autocompleteDropdown) {
      searchOverlay.style.display = "none";
     }
    });

    // HOOKS 
    algoliaShopify.hooks.registerHook('beforeAutocompleteOptions', function(options) {
        // Change the placeholder text of the autocomplete menu
        options.placeholder = "Search";
        return options;
    });

    // Modify the product results page
    algoliaShopify.hooks.registerHook('beforeInstantSearchProductTemplate', function(_defaultTemplate, hit, html, components) {
      return html`
        <div
          class="ais-hit ais-product"
          data-algolia-index="${hit.index}"
          data-algolia-position="${hit.productPosition}"
          data-algolia-queryid="${hit.queryID}"
          data-algolia-objectid="${hit.objectID}"
          data-handle="${hit.handle}"
          data-variant-id="${hit.objectID}"
          data-distinct="${hit._distinct}"
          data-product-id="${hit.id}"
          onClick="${() => algoliaShopify.helpers.handleItemClick(hit)}"
        >
        <div class="relative">
          <img
            class="ais-hit--picture"
            src="${algoliaShopify.helpers.largeImage(hit)}"
            alt="${hit.title} - ${hit.variant_title}"
          />

           ${html`
              <form
                id="algolia-add-to-cart-${hit.objectID}"
                style="display: none;"
                action="/cart/add"
                method="post"
                enctype="multipart/form-data"
              >
                <input type="hidden" name="id" value="${hit.objectID}" />
              </form>
              <p class="ais-hit--cart add-to-cart-button absolute bottom-4 left-4 right-4 z-20">
                ${hit.can_order
                  ? html`
                      <button
                        class="ais-hit--cart-button btn-add-to-cart-card transition-all transition-duration-1000 bg-opacity-80"
                        data-form-id="algolia-add-to-cart-${hit.objectID}"
                      >
                        ${algoliaShopify.translations.addToCart}
                      </button>
                    `
                  : html`
                      <button disabled
                        class="ais-hit--cart-button ais-hit--cart-button__disabled btn-add-to-cart-card transition-all transition-duration-1000 bg-opacity-80"
                      >
                        ${algoliaShopify.translations.outOfStock}
                      </button>
                    `}
              </p>
            `}
          </div>
  
          <div class="ais-hit--details">
            <p class="ais-hit--title">
              <a
                data-algolia-index="${hit.index}"
                data-algolia-position="${hit.productPosition}"
                data-algolia-queryid="${hit.queryID}"
                data-algolia-objectid="${hit.objectID}"
                href="${algoliaShopify.helpers.instantsearchLink(hit)}"
                title="${algoliaShopify.helpers.fullTitle(
                  hit.title,
                  hit._distinct,
                  hit.variant_title
                )}"
              >
                ${components.Highlight({ attribute: 'title', hit })}
                ${algoliaShopify.helpers.variantTitleAddition(hit, hit._distinct)}
              </a>
            </p>
            <p
              class="ais-hit--subtitle"
              title="${hit.product_type}${algoliaShopify.translation_helpers.by(
                hit.vendor
              )}"
            >
              ${components.Highlight({ attribute: 'product_type', hit })}
              ${hit.vendor &&
                html`
                  <span> ${algoliaShopify.translations.by} </span>
                `}
              ${hit.vendor && components.Highlight({ attribute: 'vendor', hit })}
            </p>
            <p class="ais-hit--price">
            ${!hit.meta.options.hide_price &&
              html`
               <b>${algoliaShopify.helpers.displayPrice(hit, hit._distinct)}</b>
              `}
              ${!hit._distinct &&
                html`
                  <span class="ais-hit--price-striked"
                    ><span
                      >${algoliaShopify.helpers.displayStrikedPrice(
                        hit.price,
                        hit.compare_at_price
                      )}</span
                    ></span
                  >
                `}
              ${!hit._distinct &&
                html`
                  <span class="ais-hit--price-discount"
                    >${algoliaShopify.helpers.displayDiscount(
                      hit.price,
                      hit.compare_at_price,
                      hit.price_ratio
                    )}</span
                  >
                `}
            </p>
            <!-- Extra info examples - Remove the display: none to show them -->
            <p class="ais-hit--info" style="display: none">
              ${hit.sku &&
                html`
                  <span class="algolia-sku"
                    >${components.Highlight({ attribute: 'sku', hit })}</span
                  >
                `}
              ${hit.barcode &&
                html`
                  <span class="algolia-barcode"
                    >${components.Highlight({ attribute: 'barcode', hit })}</span
                  >
                `}
              ${hit.weight &&
                html`
                  <span class="algolia-weight">${hit.weight}</span>
                `}
              ${!hit.taxable &&
                html`
                  <span class="algolia-taxable"
                    >${algoliaShopify.translations.taxFree}</span
                  >
                `}
            </p>
            <!-- Tags example - Remove the display: none to show them -->
            <p class="ais-hit--tags" style="display: none">
              ${hit?._highlightResult.tags?.map(
                tag =>
                  html`
                    <span class="ais-hit--tag">${tag.value}</span>
                  `
              )}
            </p>
            ${!hit._distinct &&
              html`
                <form
                  id="algolia-add-to-cart-${hit.objectID}"
                  style="display: none;"
                  action="/cart/add"
                  method="post"
                  enctype="multipart/form-data"
                >
                  <input type="hidden" name="id" value="${hit.objectID}" />
                </form>
                <p class="ais-hit--cart">
                  ${hit.can_order
                    ? html`
                        <button
                          class="ais-hit--cart-button"
                          data-form-id="algolia-add-to-cart-${hit.objectID}"
                        >
                          ${algoliaShopify.translations.addToCart}
                        </button>
                      `
                    : html`
                        <button
                          class="ais-hit--cart-button ais-hit--cart-button__disabled"
                        >
                          ${algoliaShopify.translations.outOfStock}
                        </button>
                      `}
                </p>
              `}
          </div>
        </div>
      `;
    });   

    // Modify the autocomplete search dropdown
    algoliaShopify.hooks.registerHook(
      "beforeAutocompleteProductTemplate",
      function (_defaultTemplate, templateOptions, distinct, itemLink) {
        // Modify default options, then return them
        const { html, item, components } = templateOptions;
        // Client request in BOOS-1880 - Hide prices over 100,000 and display POA
        let priceFormatted = algoliaShopify.helpers.displayPrice(item, distinct);
        if (item.price >= 100000){
          priceFormatted = 'POA';
        }
        return html`
      <a
        href="${itemLink}"
        class="aa-ItemLink aa-ProductItem"
        onClick="${() => algoliaShopify.helpers.handleItemClick(item)}"
      >
        <div class="aa-ItemContent">
          <div class="aa-ItemPicture aa-ItemPicture--loaded">
            <img
              src="${algoliaShopify.helpers.largeImage(item)}"
              alt="${item.title}"
            />
          </div>
          <div class="aa-ItemContentBody">
            <div class="aa-ItemContentBrand">
              ${
                item.product_type &&
                components.Highlight({ hit: item, attribute: "product_type" })
              }
             removing vendor
            </div>
            <div class="aa-ItemContentTitleWrapper">
              <div class="aa-ItemContentTitle">
                ${components.Highlight({ hit: item, attribute: "title" })}
                <span class="algolia-variant">
                  ${algoliaShopify.helpers.variantTitleAddition(item, distinct)}
                </span>
              </div>
            </div>
            <div class="aa-ItemContentPrice">
              <div class="aa-ItemContentPriceCurrent">
              ${priceFormatted}
              </div>
            </div>
          </div>
        </div>
      </a>
    `;
      }
    );
  });
  